// A row's other actions under its More (DESIGN.md §3: one action a row at rest). The actions are drawn
// only once it's opened, so at rest the row offers its one action and a word to see the rest.
import { useState, type ReactNode } from 'react';

export function RowMore({ about, children }: { about: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="bp-more">
      <button
        type="button"
        className="bp-more-toggle"
        aria-expanded={open}
        aria-label={open ? `Fewer actions for ${about}` : `More for ${about}`}
        onClick={() => setOpen(!open)}
      >
        {open ? 'Less' : 'More'}
      </button>
      {open && <div className="bp-more-body">{children}</div>}
    </div>
  );
}
